import { Navigate, Route, Routes } from 'react-router-dom'
import { PublicDatabase } from './PublicDatabase'

export function Database() {
  return (
    <Routes>
      <Route index element={<PublicDatabase />} />
      <Route path="*" element={<Navigate to="/database" replace />} />
    </Routes>
  )
}
